import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { liveApi } from "@/lib/api/live";
import { locationApi } from "@/lib/api";
import { LiveRiskMap } from "@/components/floodwatch/live-risk-map";

export const Route = createFileRoute("/app/map")({
  head: () => ({
    meta: [{ title: "Map" }],
  }),
  component: MapTab,
});

function MapTab() {
  const locationStatus = useQuery({
    queryKey: ["user", "location", "status"],
    queryFn: () => locationApi.getLocationStatus(),
    retry: 1,
    refetchInterval: 60_000,
  });

  const placeRisks = useQuery({
    queryKey: ["user", "live", "place-risks"],
    queryFn: () => liveApi.userPlaceRisks(),
    retry: 1,
  });

  const mapLayers = useQuery({
    queryKey: ["user", "map", "layers", "v2"],
    queryFn: () => liveApi.userMapLayers(),
    refetchInterval: 60_000,
    retry: 1,
  });

  const serverLive = locationStatus.data?.live;
  const hereRisk = placeRisks.data?.places?.[0];
  const areaWard = serverLive?.ward || hereRisk?.ward || "";
  const areaCounty = serverLive?.county || hereRisk?.county || "";

  const center =
    locationStatus.data?.lastLive?.latitude != null &&
    locationStatus.data?.lastLive?.longitude != null
      ? {
          lat: locationStatus.data.lastLive.latitude,
          lng: locationStatus.data.lastLive.longitude,
        }
      : areaCounty?.toLowerCase().includes("kiambu") || areaWard?.toLowerCase().includes("juja")
        ? { lat: -1.1018, lng: 37.0144 }
        : null;

  const placeLabel = [areaWard, areaCounty].filter(Boolean).join(", ") || null;

  return (
    <section className="space-y-3">
      <div>
        <h2 className="font-display text-lg font-bold">Local risk map</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Flood zones and active alerts near your place.
        </p>
      </div>

      <LiveRiskMap
        mode="resident"
        center={center}
        zoom={12}
        placeLabel={placeLabel}
        activeAlerts={mapLayers.data?.activeAlerts}
        officialWarnings={mapLayers.data?.officialWarnings}
        approvedReports={mapLayers.data?.approvedReports?.map(r => ({ ...r, severity: r.severity ?? undefined }))}
        counts={mapLayers.data?.counts}
      />

      {mapLayers.data?.counts ? (
        <p className="text-center text-xs text-muted-foreground">
          {mapLayers.data.counts.riskAreas} risk areas · {mapLayers.data.counts.activeAlerts} alerts ·{" "}
          {mapLayers.data.counts.approvedReports} reports
        </p>
      ) : null}

      {(areaWard || areaCounty) && (
        <p className="text-xs text-muted-foreground">
          Centred on: {[areaWard, areaCounty].filter(Boolean).join(", ")}
        </p>
      )}
    </section>
  );
}
